import {AddOrgTeamMemberFormModel, CreateOrgDetailsFormModel} from '../../../core/model/create-org-details-form.model';

export class AddOrgDetailsAction {
  static readonly type = '[Org] Add Details';
  constructor(public payload: CreateOrgDetailsFormModel) {}
}

export class AddOrgTeamMemberAction {
  static readonly type = '[Org] Add Team Member';
  constructor(public payload: AddOrgTeamMemberFormModel) {}
}

export class CreateOrg {
  static readonly type = '[Org] Create';
}

export class SetOnboardingStateOp {
  static readonly type = '[Org] Set Onboarding State Op';
  constructor(public op: 'idle' | 'pending' | 'success' | 'error') {}
}
